module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "visualizar-empreendimento u-margem-superior-pequena"
  }, [_c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-centro"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_10 informacoes-emprendimento"
  }, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "nome-empreedimento grade__coluna grade__coluna_10"
  }, [_c('span', [_vm._v(_vm._s(_vm.empreendimento.Nome))])]), _vm._v(" "), (true) ? _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.redirecionarParaEdicao
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Editar\n              ")]) : _vm._e(), _vm._v(" "), (true) ? _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removerEmpreendimento
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Excluir\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Projeto:\n                "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.ProjetoDeSubsidioNome))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Cidade:\n                "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.Cidade.Nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Tipo de imóvel:\n                "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.TipoDeEmpreendimento))])])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Construtora:\n                "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.Construtora.Nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("CNPJ:\n                "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.Construtora.Cnpj))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Conta:\n                "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.Construtora.Conta))])])])]), _vm._v(" "), (_vm.empreendimento.ProjetoEhBonusMoradia) ? _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Total de cotas disponíveis no município:\n                "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.CotasDisponiveisNoMunicipio))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Cotas utilizadas no empreendimento:\n                "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.CotasDeImoveisUsadas))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v("Cota total disponibilizada no empreendimento:\n                "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.CotaDeImoveis))])])])]) : _vm._e()])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "grade__coluna"
  }, [_c('i', {
    staticClass: "fal fa-home fa-5x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0cdb20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/empreendimentos/VisualizarEmpreendimento.vue
// module id = 1092
// module chunks = 1